module.exports = __webpack_public_path__ + "img/category-fishing-game.bc0135ae.png";